import { widgets } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IWidgetData, IWidgets } from "../../models/master/widgets";

export default new (class WidgetService {
  public getWidget = async (id: number): Promise<IApiResponse<IWidgetData>> => {
    try {
      let endPoint = urlBinder(widgets.GET_WIDGET, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IWidgetData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IWidgetData>;
      } else {
        throw error;
      }
    }
  };

  public getWidgets = async (
    configUserRole?: number,
    pageBlockId?: number,
    collegeId?:number,
    noOfItems?: number
  ): Promise<IApiResponse<Array<IWidgets>>> => {
    try {
      let endPoint = urlBinder(widgets.GET_ALL_WIDGETS, [
        configUserRole,
        pageBlockId,
        collegeId,
        noOfItems,
      ]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IWidgets>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IWidgets>>;
      } else {
        throw error;
      }
    }
  };

  public createWidget = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = widgets.CREATE_WIDGET;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateWidget = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(widgets.UPDATE_WIDGET, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateWidgetPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = widgets.UPDATE_WIDGET_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteWidget = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(widgets.DELETE_WIDGET, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
